const questions = [
	{
		id: 0,
		question: '¿Cómo es la metodología de estudio en Libel Academy?',
		answer: (
			<div>
				La metodología de Libel Academy puede variar según el programa e incluir las siguientes
				modalidades: <br />
				<br />
				<ul style={{ paddingLeft: 30 }}>
					<li>
						{' '}
						<b>A tu ritmo:</b> sin acompañamiento de un maestro.
					</li>
					<li> Clases en vivo con feedback en vivo.</li>
					<li> Clases pregrabadas con feedback en vivo.</li>
				</ul>
				<br />
				La metodología específica de cada programa será informada antes de la inscripción.
			</div>
		),
	},
	{
		id: 1,
		question: '¿Dónde se ven las clases?',
		answer: (
			<div>
				<p>
					Todos los cursos en los que estás inscritos aparecerán en tu perfil, sección “mi portal”,
					es por ello por lo que debes crear un perfil en nuestra plataforma de estudio:{' '}
					<a href='https://cursos.libel.academy/users/sign_up'>
						https://cursos.libel.academy/users/sign_up.
					</a>
				</p>
				<br />
				<p>
					<b> Aclaración:</b> Solo podrás ver tus cursos en la plataforma después del inicio de
					clases.
				</p>
				<br />
				<p>
					Las clases en vivo se realizan por Zoom y el acceso a ellas se envía a través del grupo en
					Discord del curso en el cual estés inscrito. Las grabaciones de las clases en vivo también
					aparecerán en tu perfil 24 horas hábiles después de cada clase en vivo.
				</p>
			</div>
		),
	},
	{
		id: 2,
		question: 'Si el día de inicio del curso/máster no he recibido ningún acceso ¿Qué debo hacer?',
		answer: (
			<div>
				<p>
					Recuerda que el curso o máster solo estará visible en tu perfil después de la inducción,
					la cual se lleva a cabo en la fecha de inicio de clases. Para asegurarte de que todo esté
					en orden:
				</p>
				<br />
				<ol style={{ paddingLeft: 30 }}>
					<li>
						<b>Formulario de inscripción:</b> Verifica que hayas completado el formulario. Si aún no
						lo has hecho, contacta al asesor que te acompañó durante el proceso de pago para
						solicitarlo o escribe a administrativo@libeluniversity.org.
					</li>
					<br />
					<li>
						<b>Accesos a la inducción:</b> Revisa tu correo (incluidas las carpetas de spam o
						promociones) para confirmar si recibiste la información de acceso.
					</li>
					<br />
					<li>
						<b>Comprobante de pago:</b> Si aún no lo has enviado, remite el comprobante a
						coordinacion@libel.academy.
					</li>
					<br />
					<li>
						<b>Solicitud de acceso a la inducción:</b> Si sigues sin acceso, escribe a
						administrativo@libeluniversity.org para solicitarlo.
					</li>
					<br />
				</ol>
				<br />
				<b>NOTA:</b> Recuerda que los accesos a la inducción se envían 2 días antes del inicio del
				curso o máster.
			</div>
		),
	},
	{
		id: 3,
		question:
			'¿Qué hacer si tengo problemas con el uso de la plataforma, el registro o la visualización de los cursos?',
		answer: (
			<div>
				Escribe un correo a administrativo@libeluniversity.org para que puedan ayudarte. Horario de
				soporte: Lunes a viernes, de 8:00 a. m. a 5:00 p. m. (hora Colombia). La respuesta a tu
				solicitud puede tardar entre 1 y 2 días hábiles, por lo que agradecemos tu paciencia.
			</div>
		),
	},
	{
		id: 4,
		question: '¿Qué tipo de certificado se obtiene?',
		answer: (
			<div>
				A excepción del contenido gratuito, todos nuestros cursos, másteres y talleres incluyen
				certificación. Para obtenerla, es necesario que tus resultados sean aprobados, en cuyo caso
				se te otorgará un certificado de cumplimiento de metas. Algunos certificados pueden contar
				con aval universitario, mientras que otros no. Por ello, es importante que verifiques si tu
				inscripción lo incluía y conozcas los requisitos para obtenerlo. Independientemente de si
				tienen aval, todos los certificados reflejan el cumplimiento de metas y son otorgados tras
				un proceso de evaluación de tus resultados.
			</div>
		),
	},
	{
		id: 5,
		question: '¿Proporcionan las licencias de los softwares que se usan en los cursos?',
		answer: (
			<div>
				En general, los contenidos no incluyen licencias de software. Sin embargo, en algunos casos,
				las únicas licencias disponibles para entrega y/o venta son las de Reallusion (Character
				Creator, iClone, Headshot, entre otras). Cuando esto aplique, se informará en los cursos o
				másteres correspondientes.
				<br />
				Te recomendamos verificar esta información antes de tu inscripción. Para más detalles,
				puedes escribir a info@libel.academy.
			</div>
		),
	},
	{
		id: 6,
		question: '¿Cuál es la diferencia entre un máster y un curso en vivo?',
		answer: (
			<div>
				Los másteres abarcan una variedad de temas y softwares, incluyen cursos complementarios en
				vídeo y están diseñados para un nivel intermedio-avanzado. Por otro lado, los cursos se
				enfocan en un único tema y software, con un nivel básico-intermedio.
				<br />
				Las diferencias entre cada máster y curso pueden variar significativamente. Te recomendamos
				agendar una asesoría gratuita por Zoom para obtener más información y elegir la mejor opción
				para ti.
			</div>
		),
	},
	{
		id: 7,
		question: '¿Qué medios de pago tienen?',
		answer: (
			<div>
				Puedes realizar tu pago a través de transferencia bancaria, PSE, tarjeta débito/crédito,
				Efecty, PayPal y Western Union.
				<br />
				<b>Importante:</b> PayPal no está disponible para Colombia.
			</div>
		),
	},
	{
		id: 8,
		question: '¿Tienen planes de financiación?',
		answer: (
			<div>
				Sí, ofrecemos planes de financiación para nuestros cursos y másteres con feedback en vivo.
				Para acceder a esta opción, te recomendamos agendar una asesoría gratuita por Zoom, donde
				podremos brindarte más detalles y ayudarte con el proceso.
			</div>
		),
	},
	{
		id: 9,
		question: '¿Cuál es el horario de atención de Libel Academy?',
		answer: (
			<div>
				<b>Atención Administrativa</b>
				<ul>
					<li>
						<b>Lunes a viernes:</b> 8:00 a. m. - 5:00 p. m. (hora Colombia)
					</li>
					<li>
						<b>Sábados:</b> 8:00 a. m. - 11:00 a. m. (hora Colombia)
					</li>
					<li>
						<b>Domingos y festivos:</b> No hay atención.
					</li>
				</ul>
				<br />
				<b>Atención Financiera</b>
				<ul>
					<li>
						<b>Lunes a viernes:</b> 9:00 a. m. - 5:00 p. m. (hora Colombia)
					</li>
					<li>
						<b>Sábados, domingos y festivos: </b> No hay atención.
					</li>
				</ul>
				<br />
				<b>Soporte Técnico</b>
				<ul>
					<li>
						<b>Lunes a viernes:</b> 8:00 a. m. - 5:00 p. m. (hora Colombia)
					</li>
					<li>
						<b>Sábados, domingos y festivos: </b> No hay atención.
					</li>
				</ul>
				<br />
				<b>Canales de Venta</b>
				<br />
				Los canales de venta suelen tener horarios extendidos en comparación con el área
				administrativa. Sin embargo, si escribes después de las 6:00 p. m. o los sábados en la
				tarde, la respuesta puede tardar más o no darse hasta el siguiente día hábil.
				<ul>
					<li>
						<b>Domingos y festivos: </b> No hay atención.
					</li>
				</ul>
				<br />
				<b>Asesorías para Estudiantes o Aspirantes</b>
				<br />
				Las asesorías pueden agendarse en un horario diferente al administrativo. Consulta el
				calendario de asesorías de tu asesor para conocer los horarios disponibles. Si aún no tienes
				asesor, puedes solicitar uno a través del ícono de WhatsApp en nuestra página web.
				<br />
				<br />
				<b>Importante:</b> Los horarios de clases, conferencias y/o eventos son independientes de
				los mencionados anteriormente y deben consultarse directamente en cada curso.
			</div>
		),
	},
];

export default questions;
